import { useQueryClient } from "@tanstack/react-query";

import { HUB_CACHE_CHANNEL } from "@/lib/hubCacheChannels";
import { useHubCacheStream } from "@/lib/useHubCacheStream";

/** Invalidate AP invoice list/detail when AI review (or reset) changes status. */
export function useAccountingApInvoicesLiveQueries(enabled = true): void {
  const queryClient = useQueryClient();
  useHubCacheStream({
    channels: [HUB_CACHE_CHANNEL.accountingApInvoices],
    enabled,
    onEvent: (event) => {
      if (event.phase === "connected") {
        return;
      }
      void queryClient.invalidateQueries({ queryKey: ["accounting", "ap-invoices"] });
      void queryClient.invalidateQueries({ queryKey: ["accounting", "ap-invoice"] });
    },
  });
}
